import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes as Switch } from 'react-router-dom'
import { userActions } from './store/actions/user'
import { accountLoadables, homeLoadables, newsLoadables, projectLoadables } from "./loadables"
import Nri from './containers/NRI'
import NotFound from './components/NotFound'
import OneNews from './containers/News/OneNews'
import OneHelp from './containers/HelpSection/OneHelp/OneHelp'
import ProjectLibrary from './containers/ProjectLibrary'
import CreateProject from './containers/ProjectLibrary/CreateProject'
import ConstructorCostBase from "./containers/Constructor/CostBase"
import ConstructorResourceBase from "./containers/Constructor/ResourceBase"
import Reporting from './containers/Reporting'
import EditProject from './containers/ProjectLibrary/OneProjectView/EditProject'
import isRole from './helpers/userHelper'
import HelpList from './containers/HelpSection/HelpList'
import HelpSection from './containers/HelpSection'
import GlobalLoading from './components/Loading/Global'

const Routes = () => {
	const dispatch = useDispatch()
	const { user, refreshTokenLoading } = useSelector(state => state.userReducer)
	useEffect(() => {
		dispatch(userActions.refreshUserData({}))
	}, [])

	return (
		<Switch>
			<Route
				element={<homeLoadables.LoadableHome />}
				path="/"
			/>
			{
				Boolean(user?.isLoggedIn) &&
				(
					<Route
						element={<accountLoadables.LoadableAccount />}
						path="/account"
					/>
				)}
			{
				isRole(["mainAdmin", "analogObjectsMainAdmin", "analogObjectsProjectAdmin"], user) &&
				(
					<Route
						element={(
							<Nri
								withHeader
								withCatalog={false}
							/>
						)}
						path="/nsi"
					/>
				)
			}
			<Route
				element={(
					<Reporting />
				)}
				path="/reporting"
			/>
			<Route
				element={(
					<ProjectLibrary />
				)}
				path="/projects"
			/>
			<Route
				element={<projectLoadables.LoadableOneProject />}
				path="/project/:id"
			/>
			{
				isRole(["mainAdmin", "analogObjectsMainAdmin", "analogObjectsProjectAdmin"], user) &&
				(
					<Route
						element={(
							<CreateProject />
						)}
						path="/createProject"
					/>
				)
			}
			{
				isRole(["mainAdmin", "analogObjectsMainAdmin", "analogObjectsProjectAdmin"], user) &&
				(
					<Route
						element={<EditProject />}
						path="/editProject/:id"
					/>
				)
			}
			{
				// (Boolean(user?.isConstructorPay) || isRole(["mainAdmin", "analogObjectsMainAdmin", "analogObjectsFocusGroup"], user)) &&
				(
					<>
						<Route
							element={<ConstructorCostBase />}
							path="/costBase/:id?"
						/>
						<Route
							element={<ConstructorResourceBase />}
							path="/resourceBase/:id?"
						/>
					</>
				)
			}
			<Route
				element={<HelpSection />}
				path="/help"
			>
				<Route
					element={<HelpList />}
					path=""
				/>
				<Route
					element={<OneHelp />}
					path=":id"
				/>
			</Route>
			{
				isRole(["mainAdmin", "analogObjectsMainAdmin", "analogObjectsContentAdmin"], user) &&
				(
					<>
						<Route
							element={<newsLoadables.LoadableAddNews />}
							path="/createNews"
						/>
						<Route
							element={<newsLoadables.LoadableAddNews />}
							path="/editNews/:id"
						/>
						<Route
							element={<OneNews />}
							path="/oneNews/:newsId"
						/>
					</>
				)
			}
			<Route
				element={refreshTokenLoading ? <GlobalLoading /> : <NotFound />}
				path="*"
			/>
		</Switch>
	)
}

export default Routes